import { Link } from 'react-router-dom';

interface MovieCardProps {
  id: number;
  title: string;
  category: string;
  rating: number;
  year: number;
  region: string;
  coverImage: string;
  tags: string[];
  updateTime: string;
  duration: string;
}

const categoryNames: Record<string, string> = {
  dianying: '电影',
  dianshiju: '电视剧',
  zongyi: '综艺',
  dongman: '动漫',
};

export default function MovieCard({
  id,
  title,
  category,
  rating,
  year,
  region,
  coverImage,
  tags,
  duration,
}: MovieCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[2/3] bg-background-200">
        <img
          src={coverImage}
          alt={`${title} - 木瓜影院高清${categoryNames[category] || category}`}
          title={`${title} - 木瓜影院高清${categoryNames[category] || category}`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
        <div className="absolute top-2 left-2">
          <span className="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-primary-500/90 text-foreground-50 text-xs font-semibold">
            <i className="ri-star-fill text-xs"></i>
            {rating}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span className="inline-flex px-2 py-1 rounded-md bg-background-950/60 text-foreground-200 text-xs">
            {categoryNames[category] || category}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="text-sm font-semibold text-white truncate mb-1">{title}</h3>
          <div className="flex items-center gap-2 text-xs text-foreground-300">
            <span>{year}</span>
            <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
            <span>{region}</span>
            <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
            <span>{duration}</span>
          </div>
        </div>
      </div>
      <div className="mt-2 flex items-center gap-1 flex-wrap">
        {tags.slice(0, 2).map((tag) => (
          <span
            key={tag}
            className="px-2 py-0.5 rounded text-xs bg-secondary-100 text-secondary-700"
          >
            {tag}
          </span>
        ))}
      </div>
    </Link>
  );
}